module.exports = __webpack_public_path__ + "img/cybercircuits_mobile.eaa4000d.png";